'use strict';

const Backbone = require('backbone');

module.exports = class ReadMore extends Backbone.Model {
    constructor(attributes) {
        super(attributes);
    }

    get value() {
        return this.get('value');
    }

    get page() {
        return this.get('page');
    }

    get type() {
        return this.get('type');
    }

    more(limit) {
        this.trigger(`readmore:${this.type}`, limit, this.page);
    }
};



// WEBPACK FOOTER //
// ./framework/domain/value/readmore.js